<template>
<div>
  <div class="contenedor_tabla-titulo">
    <img src="@/assets/image/logoolimpiadas.png" class="img_logo_medallero-tokio" /> <h4>Medallero Olímpico</h4>
  </div>
  <table cellpadding="0" cellspacing="0"  class="table table table-striped tabla_medallero">
    <thead>
      <tr class="tabla_info">
        <th>Posición</th>
        <th>País</th>
        <th class="text-center"><div class="oro"></div> <p>Oro</p></th>
        <th class="text-center"><div class="plata"></div> <p>Plata</p></th>
        <th class="text-center"><div class="bronce"></div> <p>Bronce</p></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in medalleroOlimpico" :key="index">
        <td>{{ index + 1 }}</td>
        <td class="text-left"><img :src="require(`@/assets/banderas/${item.bandera}.jpg`)" class="img_bandera"/> <p>{{ item.Pais }}</p></td>
        <td>{{ item.Oro }}</td>
        <td>{{ item.Plata }}</td>
        <td>{{ item.Bronce }}</td>
      </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      medalleroOlimpico: []
    }
  },
  methods: {
   async getDataMedal () {
     try {
      const result = await axios.get('https://webmr.cl/api-jjoo/api/medallero')
      if (result.data) {
        this.medalleroOlimpico = result.data
      }
     } catch (error) { console.log(error) }
    }
  },
  mounted() {
    this.getDataMedal()
  }
}
</script>